import React, { createContext, useCallback, useEffect, useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import * as mixpanel from 'mixpanel-browser';

export const TrackerContext = createContext({});

const mixpanelId = process.env.MIXPANEL_PROJECT_TOKEN || '';

function TrackerProvider({ children }) {
  const [isReady, setIsReady] = useState(false);

  // Set user id
  const setUserId = useCallback((userId) => {
    mixpanel.identify(userId);
  }, []);

  // Event Name & Properties
  const eventTracker = useCallback(
    (name, props = {}) => {
      if (!isReady) {
        return;
      }
      const trackerResult = mixpanel.track(name, props);
      return trackerResult;
    },
    [isReady]
  );

  // Reset Tracker
  const resetTracker = useCallback(() => {
    const reset = mixpanel.reset();
    return reset;
  }, []);

  // Tracker initialization
  useEffect(() => {
    if (!isReady) {
      mixpanel.init(mixpanelId);
      setIsReady(true);
    }
  }, [isReady]);

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const trackerContextValue = { isReady, setUserId, eventTracker, resetTracker };

  return <TrackerContext.Provider value={trackerContextValue}>{children}</TrackerContext.Provider>;
}

export default TrackerProvider;
